var _rect, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTeamPlanIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.333496,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#DCDAFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.66675 15.9999L16.0949 19.214C16.1824 19.2577 16.2261 19.2795 16.2719 19.2882C16.3126 19.2958 16.3543 19.2958 16.3949 19.2882C16.4407 19.2795 16.4845 19.2577 16.5719 19.214L23.0001 15.9999M9.66675 19.3332L16.0949 22.5473C16.1824 22.591 16.2261 22.6129 16.2719 22.6215C16.3126 22.6291 16.3543 22.6291 16.3949 22.6215C16.4407 22.6129 16.4845 22.591 16.5719 22.5473L23.0001 19.3332M9.66675 12.6665L16.0949 9.45247C16.1824 9.40874 16.2261 9.38688 16.2719 9.37827C16.3126 9.37065 16.3543 9.37065 16.3949 9.37827C16.4407 9.38688 16.4845 9.40874 16.5719 9.45247L23.0001 12.6665L16.5719 15.8806C16.4845 15.9244 16.4407 15.9462 16.3949 15.9548C16.3543 15.9624 16.3126 15.9624 16.2719 15.9548C16.2261 15.9462 16.1824 15.9244 16.0949 15.8806L9.66675 12.6665Z",
    stroke: "#5148D7",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamPlanIcon);
export default __webpack_public_path__ + "static/media/Team-plan-icon.93c5a515.svg";
export { ForwardRef as ReactComponent };